import axiosInstance from "../axios/axiosInstance";
import ENV from "constants/env";

const companyId = () => localStorage.getItem("companyId") || ENV.COMPANY_ID;

// /api/companies/{id}/payrolls
export const getPayrolls = async () => {
    const res = await axiosInstance.get(`/companies/${companyId()}/payrolls`, {
        params: { page: 1, pageSize: 1000 }
    });
    const data = res.data;
    return Array.isArray(data) ? data : (data?.data ?? []);
};

export const getPayroll = async (payrollId) => {
    return (await axiosInstance.get(`/companies/${companyId()}/payrolls/${payrollId}`)).data;
};

export const createPayroll = async (payload) => {
    return (await axiosInstance.post(`/companies/${companyId()}/payrolls`, payload)).data;
};

export const approvePayroll = async (payrollId) => {
    return (await axiosInstance.post(`/companies/${companyId()}/payrolls/${payrollId}/approve`)).data;
};

export const voidPayroll = async (payrollId) =>
    (await axiosInstance.post(`/companies/${companyId()}/payrolls/${payrollId}/void`)).data;

export const reopenPayroll = async (payrollId) => {
    return (await axiosInstance.post(`/companies/${companyId()}/payrolls/${payrollId}/reopen`)).data;
};

export const deletePayroll = async (payrollId) => {
    return (await axiosInstance.delete(`/companies/${companyId()}/payrolls/${payrollId}`)).data;
};

export const previewPayroll = async (payrollId) => {
    return (await axiosInstance.get(`/companies/${companyId()}/payrolls/${payrollId}/preview`)).data;
};

export const updatePayroll = async ({ payrollId, ...payload }) => {
    return (await axiosInstance.patch(`/companies/${companyId()}/payrolls/${payrollId}`, payload)).data;
};

export const getPayrollAuditLog = async ({ payrollId, limit = 200 } = {}) => {
    const params = new URLSearchParams({ limit });
    if (payrollId) params.set('payrollId', payrollId);
    return (await axiosInstance.get(`/companies/${companyId()}/payrolls/audit-log?${params}`)).data;
};

export const getPayrollJournal = async (payrollId) => {
    try { return (await axiosInstance.get(`/companies/${companyId()}/payrolls/${payrollId}/journal`)).data; }
    catch { return null; }
};
